import { render, staticRenderFns } from "./user-validation-messages.vue?vue&type=template&id=35256d7c&"
import script from "./user-validation-messages.vue?vue&type=script&lang=ts&"
export * from "./user-validation-messages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports